import { createFileRoute } from "@tanstack/react-router";
import { actions } from "../../lib/actions.ts";
import { DataScreen } from "../../screens/data/DataScreen.tsx";
import { DATA_TABS, type DataSearch, type DataTab } from "../../screens/data/search.ts";

/** `/data`: what Adea reads (`?view=changes`), and `?source=` brings one source into view. */
export const Route = createFileRoute("/_app/data")({
  validateSearch: (search: Record<string, unknown>): DataSearch => {
    // connecting is the panel (`?connect=`), not a view of its own; an old `view=connect` became one before this
    const view =
      DATA_TABS.includes(search.view as DataTab) && search.view !== "connect"
        ? (search.view as DataTab)
        : undefined;
    const source = typeof search.source === "string" && search.source.length < 64 ? search.source : undefined;
    return {
      ...(view && view !== "sources" ? { view } : {}),
      ...(source ? { source } : {}),
    };
  },
  loader: ({ context }) => context.queryClient.prefetchQuery(actions.queryOptions("data.sources", {})),
  component: DataScreen,
});
